import script from "./CustomButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomButton.vue?vue&type=script&setup=true&lang=js"

import "./CustomButton.vue?vue&type=style&index=0&id=622c4455&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622c4455"]])

export default __exports__